var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.stars),function(star,idx){return _c('a',{key:idx,staticClass:"testimonials-form__star",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.change(idx, $event)}}},[_c('i',{staticClass:"far fa-star",class:{ 'checked': star.checked }})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }